var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditCardPostPayment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #a3a3a2;\n      }\n\n      .cls-3 {\n        fill: none;\n      }\n\n      .cls-4 {\n        fill: #a1a0a0;\n      }\n\n      .cls-2, .cls-5 {\n        opacity: .5;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M112.5,85c0,9.1-7.4,16.6-16.6,16.6s-15.4-6.2-16.4-14.5l1.8-.2c.9,7.4,7.2,12.9,14.7,12.9s15-6.6,14.8-14.8c-.5-17.5-23-18.4-27.9-6.8h7.2v1.8h-10.7v-10.6h1.8v8.1c2.8-5.5,8.5-9.1,14.8-9.1,9.1,0,16.6,7.4,16.6,16.6Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "102.1 92.6 95 85.4 95 75.2 96.9 75.2 96.9 84.6 103.4 91.3 102.1 92.6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.6,74.7h-7.4c-1.2,0-2.2-1-2.2-2.2v-16.8h9.6v19ZM38.7,43.6c-.4,0-.8,0-1.2.2h-12.5v-5.2c0-1.2,1-2.2,2.2-2.2h54.1c1.3,0,2.4,1.1,2.4,2.4v4.8h-44.9ZM92.6,43.6h-7.2v-4.8c0-2.3-1.9-4.2-4.2-4.2H27.2c-2.2,0-4,1.8-4,4v33.9c0,2.2,1.8,4,4,4h7.4v4.8c0,2.3,1.9,4.2,4.2,4.2h31.4c0-.3,0-.6,0-.9s0-.6,0-.9h-31.4c0,0-.2,0-.2,0-.2,0-.5,0-.7-.2,0,0-.1,0-.2-.1-.2-.1-.4-.3-.5-.4-.4-.4-.7-1-.7-1.7v-33.5c0-1.3,1.1-2.4,2.4-2.4h53.9c1.3,0,2.4,1.1,2.4,2.4v11c.3,0,.6,0,.9,0s.6,0,.9,0v-11c0-2.3-1.9-4.2-4.2-4.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M42.3,58.1v.2c0,.9.7,1.5,1.5,1.5h9.4c.5,0,1-.3,1.3-.7.2-.2.3-.6.3-.9v-.2h-12.5ZM42.3,58.1v.2c0,.9.7,1.5,1.5,1.5h9.4c.5,0,1-.3,1.3-.7.2-.2.3-.6.3-.9v-.2h-12.5ZM42.3,58.1v.2c0,.9.7,1.5,1.5,1.5h9.4c.5,0,1-.3,1.3-.7.2-.2.3-.6.3-.9v-.2h-12.5ZM42.3,58.1v.2c0,.9.7,1.5,1.5,1.5h9.4c.5,0,1-.3,1.3-.7.2-.2.3-.6.3-.9v-.2h-12.5ZM42.3,58.1v.2c0,.9.7,1.5,1.5,1.5h9.4c.5,0,1-.3,1.3-.7.2-.2.3-.6.3-.9v-.2h-12.5ZM42.3,58.1v.2c0,.9.7,1.5,1.5,1.5h9.4c.5,0,1-.3,1.3-.7.2-.2.3-.6.3-.9v-.2h-12.5ZM42.3,58.1v.2c0,.9.7,1.5,1.5,1.5h9.4c.5,0,1-.3,1.3-.7.2-.2.3-.6.3-.9v-.2h-12.5ZM42.3,58.1v.2c0,.9.7,1.5,1.5,1.5h9.4c.5,0,1-.3,1.3-.7.2-.2.3-.6.3-.9v-.2h-12.5ZM42.3,58.1v.2c0,.9.7,1.5,1.5,1.5h9.4c.5,0,1-.3,1.3-.7.2-.2.3-.6.3-.9v-.2h-12.5ZM42.3,58.1v.2c0,.9.7,1.5,1.5,1.5h9.4c.5,0,1-.3,1.3-.7.2-.2.3-.6.3-.9v-.2h-12.5ZM42.3,58.1v.2c0,.9.7,1.5,1.5,1.5h9.4c.5,0,1-.3,1.3-.7.2-.2.3-.6.3-.9v-.2h-12.5ZM42.3,58.1v.2c0,.9.7,1.5,1.5,1.5h9.4c.5,0,1-.3,1.3-.7.2-.2.3-.6.3-.9v-.2h-12.5ZM42.3,58.1v.2c0,.9.7,1.5,1.5,1.5h9.4c.5,0,1-.3,1.3-.7.2-.2.3-.6.3-.9v-.2h-12.5ZM42.3,58.1v.2c0,.9.7,1.5,1.5,1.5h9.4c.5,0,1-.3,1.3-.7.2-.2.3-.6.3-.9v-.2h-12.5ZM42.3,58.1v.2c0,.9.7,1.5,1.5,1.5h9.4c.5,0,1-.3,1.3-.7.2-.2.3-.6.3-.9v-.2h-12.5ZM42.3,58.1v.2c0,.9.7,1.5,1.5,1.5h9.4c.5,0,1-.3,1.3-.7.2-.2.3-.6.3-.9v-.2h-12.5ZM42.3,58.1v.2c0,.9.7,1.5,1.5,1.5h9.4c.5,0,1-.3,1.3-.7.2-.2.3-.6.3-.9v-.2h-12.5ZM42.3,58.1v.2c0,.9.7,1.5,1.5,1.5h9.4c.5,0,1-.3,1.3-.7.2-.2.3-.6.3-.9v-.2h-12.5ZM42.3,58.1v.2c0,.9.7,1.5,1.5,1.5h9.4c.5,0,1-.3,1.3-.7.2-.2.3-.6.3-.9v-.2h-12.5ZM42.3,58.1v.2c0,.9.7,1.5,1.5,1.5h9.4c.5,0,1-.3,1.3-.7.2-.2.3-.6.3-.9v-.2h-12.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 41.8,
    y: 72.7,
    width: 9.9,
    height: 3.8
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 41.8,
    y: 65,
    width: 26.9,
    height: 3.8
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 42.3,
    y: 52.5,
    width: 3.1,
    height: 4.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.8,51.3v.3h-12.5v-.3c0-.9.7-1.5,1.6-1.5h9.4c.9,0,1.6.7,1.6,1.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 51.7,
    y: 52.5,
    width: 3.1,
    height: 4.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.8,58.1v.2c0,.9-.7,1.5-1.6,1.5h-9.4c-.9,0-1.6-.7-1.6-1.5v-.2h12.5Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 46.3,
    y: 52.5,
    width: 4.5,
    height: 4.7
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardPostPayment);
export default __webpack_public_path__ + "static/media/credit-card-post-payment.c60db36425d79e78bd99b6fdde27767f.svg";
export { ForwardRef as ReactComponent };